import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { CONNECTOR_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API коннекторов EyeHub (identities on-prem инсталляций).
 *
 * Провайдерская сторона: список коннекторов (IsHubStaff) + отзыв сертификата
 * (revoke, IsHubAdmin). Бэкенд-фильтры: `status`, `installation`; поиск —
 * по `cert_serial` / `cert_fingerprint` / `agent_version`; сортировка —
 * `created_at` / `last_heartbeat_at`.
 *
 * Контракт коннектора: {id, installation, cert_serial, cert_fingerprint, status,
 * last_heartbeat_at, agent_version, created_at, updated_at} — организация,
 * площадка и host_label резолвятся по UUID `installation` на стороне портала
 * (см. store/redux/api/connectors/useEntityLabels.js).
 * Список — UnifiedOffsetPagination ({results, count, ...}).
 */
export const connectorsApi = createApi({
  reducerPath: "connectorsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Connector"],
  endpoints: (builder) => ({
    getConnectors: builder.query({
      query: ({
        limit = 20,
        offset = 0,
        search,
        status,
        installation,
        ordering,
      } = {}) => ({
        url: CONNECTOR_ENDPOINTS.LIST,
        method: "GET",
        params: {
          limit,
          offset,
          ...(search ? { search } : {}),
          ...(status ? { status } : {}),
          ...(installation ? { installation } : {}),
          ...(ordering ? { ordering } : {}),
        },
      }),
      providesTags: [{ type: "Connector", id: "LIST" }],
    }),

    // Отзыв коннектора (IsHubAdmin) — POST connectors/{id}/revoke/.
    revokeConnector: builder.mutation({
      query: (id) => ({ url: CONNECTOR_ENDPOINTS.REVOKE(id), method: "POST" }),
      invalidatesTags: [{ type: "Connector", id: "LIST" }],
    }),

    // Просьба инсталляции собрать диагностический бандл (Ц13). Payload-free сообщение
    // канала: собирать или нет решает человек на стороне клиники, авто-исполнения нет.
    // Инвалидация списка — чтобы обновилась колонка «В очереди».
    requestDiagnostics: builder.mutation({
      query: ({ installation, ticket }) => ({
        url: "diagnostic-bundles/request/",
        method: "POST",
        body: { installation, ...(ticket ? { ticket } : {}) },
      }),
      invalidatesTags: [{ type: "Connector", id: "LIST" }],
    }),
  }),
});

export const {
  useGetConnectorsQuery,
  useRevokeConnectorMutation,
  useRequestDiagnosticsMutation,
} = connectorsApi;

export default connectorsApi;
